import React from "react";
import {
  Button,
  Modal,
  Form,
  Image,
  Col,
  Row,
  ButtonToolbar,
  ButtonGroup,
  InputGroup,
} from "react-bootstrap";
import ImageFoodGroup from "./foodGroupComponent/ImageFoodGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarker,
  faPencilAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { getfooditemsbyfoodgroupID } from "../../api/Api";
import * as allergensIcons from "../../styles/allergens";
import FontList from "../../styles/FontList";
import UploadImage from "./commons/UploadImage";
const listFont = FontList;

class FoodGroup_Land extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_delete: false,
      show_modify: false,
      color_bg: this.props.item.background,
      color_bg_canc: this.props.item.background,
      Diamond_bg: this.props.item.Diamondbackground,
      Diamond_bg_canc: this.props.item.Diamondbackground,
      width_size: this.props.item.widthSize,
      height_size: this.props.item.heightSize,
      type_size: this.props.item.typeSize,
      zindex_bg: this.props.item.zIndex,
      zindex_bg_canc: this.props.item.zIndex,
      foodgroup: [],
      id_foodgroup: this.props.item.id,
      foodgroup_validation: "",
      switchbackground: true,
      switchDiamondbackground_canc: "",
      switchDiamondbackground: this.props.item.switchDiamondbackground,
      switchSplitStyle_canc: "",
      switchSplitStyle: this.props.item.switchSplitStyle,
      
      headerImage: this.props.item.headerImage,
      headerImage_canc: this.props.item.headerImage,
      //Color
      color_primary: this.props.item.colorPrimary,
      color_primary_canc: this.props.item.colorPrimary,
      color_accent: this.props.item.colorAccent,
      color_accent_canc: this.props.item.colorAccent,

      //Font Family
      fontFamily_primary: this.props.item.fontFamily,
      fontFamily_primary_canc: this.props.item.fontFamily,
      fontFamily_secondary: this.props.item.fontFamilySecondary,
      fontFamily__secondary_canc: this.props.item.fontFamilySecondary,
      //Title
      fontSize_title: this.props.item.fontSizeTitle,
      fontSize_title_canc: this.props.item.fontSizeTitle,
      fontSize_titleNi: this.props.item.fontSizeTitleNi,
      fontSize_titleNi_canc: this.props.item.fontSizeTitleNi,
      fontSize_titleSec: this.props.item.fontSizeTitleSec,
      fontSize_titleSec_canc: this.props.item.fontSizeTitleSec,
      fontSize_titleSecNi: this.props.item.fontSizeTitleSecNi,
      fontSize_titleSecNi_canc: this.props.item.fontSizeTitleSecNi,

      //Description
      fontSize_description: this.props.item.fontSizeDescription,
      fontSize_description_canc: this.props.item.fontSizeDescription,
      fontSize_descriptionNi: this.props.item.fontSizeDescriptionNi,
      fontSize_descriptionNi_canc: this.props.item.fontSizeDescriptionNi,
      fontSize_descriptionSec: this.props.item.fontSizeDescriptionSec,
      fontSize_descriptionSec_canc: this.props.item.fontSizeDescriptionSec,
      fontSize_descriptionSecNi: this.props.item.fontSizeDescriptionSecNi,
      fontSize_descriptionSecNi_canc: this.props.item.fontSizeDescriptionSecNi,

      //Origin
      fontSize_origin: this.props.item.fontSizeOrigin,
      fontSize_origin_canc: this.props.item.fontSizeOrigin,
      //Calories
      fontSize_calories: this.props.item.fontSizeCalories,
      fontSize_calories_canc: this.props.item.fontSizeCalories,
      //Price
      fontSize_price: this.props.item.fontSizePrice,
      fontSize_price_canc: this.props.item.fontSizePrice,
      color_priceBg: this.props.item.colorPrice,
      color_priceBg_canc: this.props.item.colorPrice,
      color_priceTx: this.props.item.colorPriceTx,
      color_priceTx_canc: this.props.item.colorPriceTx,
      fontFamily_price: this.props.item.fontFamilyPrice,
      fontFamily_price_canc: this.props.item.fontFamilyPrice,
     
      Curved_tb: this.props.item.borderRadius,
      Curved_tb_canc: this.props.item.borderRadius,
   
      //Height_tb: this.props.item.Height,
     // Height_tb_canc: this.props.item.Height,
      
    };

    this.handleChangeIndex = this.handleChangeIndex.bind(this);
    this.handleChangeIDFoodgroup = this.handleChangeIDFoodgroup.bind(this);

    //Color
    this.handleChangeColor = this.handleChangeColor.bind(this);
    this.handleChangeColorPrimary = this.handleChangeColorPrimary.bind(this);
    this.handleChangeColorAccent = this.handleChangeColorAccent.bind(this);
    //Font Family
    this.handleChangeFontFamilyPrimary = this.handleChangeFontFamilyPrimary.bind(
      this
    );
    this.handleChangeFontFamilySecondary = this.handleChangeFontFamilySecondary.bind(
      this
    );

    //Title
    this.handleChangeFontSizeTitle = this.handleChangeFontSizeTitle.bind(this);
    this.handleChangeFontSizeTitleNi = this.handleChangeFontSizeTitleNi.bind(
      this
    );
    this.handleChangeFontSizeTitleSec = this.handleChangeFontSizeTitleSec.bind(
      this
    );
    this.handleChangeFontSizeTitleSecNi = this.handleChangeFontSizeTitleSecNi.bind(
      this
    );

    //Description
    this.handleChangeFontSizeDescription = this.handleChangeFontSizeDescription.bind(
      this
    );
    this.handleChangeFontSizeDescriptionNi = this.handleChangeFontSizeDescriptionNi.bind(
      this
    );
    this.handleChangeFontSizeDescriptionSec = this.handleChangeFontSizeDescriptionSec.bind(
      this
    );
    this.handleChangeFontSizeDescriptionSecNi = this.handleChangeFontSizeDescriptionSecNi.bind(
      this
    );
    //Origin
    this.handleChangeFontSizeOrigin = this.handleChangeFontSizeOrigin.bind(
      this
    );
    //Calories
    this.handleChangeFontSizeCalories = this.handleChangeFontSizeCalories.bind(
      this
    );
    //this.handleChangeHeight = this.handleChangeHeight.bind(this);
   // this.handleChangeWidth = this.handleChangeWidth.bind(this);
    this.handleChangeCurved = this.handleChangeCurved.bind(this);
    //Price
    this.handleChangeColorPriceTxt = this.handleChangeColorPriceTxt.bind(this);
    this.handleChangeColorPriceBg = this.handleChangeColorPriceBg.bind(this);
    this.handleChangeFontFamilyPrice = this.handleChangeFontFamilyPrice.bind(
      this
    );
    this.handleChangeFontSizePrice = this.handleChangeFontSizePrice.bind(this);

    this.handleSwitchDiamondBackground = this.handleswitchDiamondBackground.bind(this)
  }

  componentDidMount() {
    if (this.state.switchDiamondbackground === undefined)
    {
    this.setState({ switchDiamondbackground: false });
    }
    if (this.state.switchSplitStyle === undefined)
      {
      this.setState({ switchSplitStyle: false });
      }
   
    this.getFoodItems();
    //console.log("didMount")
   // console.log(this.props.item.widthSize);
   // console.log(this.state.width_size);
    
  }

  //MODAL DELETE
  //Close
  handleCloseDelete = () => {
    this.setState({ show_delete: false });
  };
  //Open
  handleShowDelete = () => {
    this.setState({ show_delete: true });
  };
  //MODAL MODIFY
  //Close
  handleCloseModify = () => {
    this.setState({ show_modify: false });
  };
  //Open
  handleShowModify = () => {
    this.setState({ show_modify: true });
  };
  //Change Color Background
  handleChangeColor(event) {
    this.setState({ color_bg: event.target.value });
  }

  //Transparent
  handleswitchBackground = (event) => {
    this.setState({ switchbackground: event.target.checked });
    if (this.state.switchbackground === true) {
      this.setState({ color_bg: "transparent" });
    } else {
      this.setState({ color_bg: this.state.color_bg_canc });
    }
  };
  handleswitchDiamondBackground = (event) => {
   
    this.setState({ switchDiamondbackground: event.target.checked });
   /* if (this.state.switchDiamondbackground === true) {
      this.setState({ Diamond_bg: "../image/point_badge.png" });
    } else {
      this.setState({ Diamond_bg: "../image/point_badge.png" });
    }*/
  };
  handleswitchSplitStyle = (event) => {
   console.log(event.target.checked);
    this.setState({ switchSplitStyle: event.target.checked });
  /*  if (this.state.switchSplitStyle === true) {
      this.setState({ switchSplitStyle: true });
    } else {
      this.setState({ switchSplitStyle: "../image/point_badge.png" });
    }*/
  };
    

  //Change COLOR
  //Change Color PRIMARY
  handleChangeColorPrimary(event) {
    this.setState({ color_primary: event.target.value });
  }
  //Change Color ACCENT
  handleChangeColorAccent(event) {
    this.setState({ color_accent: event.target.value });
  }

  // Change FONT FAMILY
  //Change Font Family Primary
  handleChangeFontFamilyPrimary(event) {
    this.setState({ fontFamily_primary: event.target.value });
  }

  //Change Font Family Secondary
  handleChangeFontFamilySecondary(event) {
    this.setState({ fontFamily_secondary: event.target.value });
  }

  // TITLE SIZE
  //Change Font SIZE Title
  handleChangeFontSizeTitle(event) {
    if (event.target.value > 100) {
      this.setState({ fontSize_title: 50 });
    } else if (event.target.value < 25) {
      this.setState({ fontSize_title: 25 });
    } else {
      this.setState({ fontSize_title: event.target.value });
    }
  }
  //Change Font SIZE Title no image
  handleChangeFontSizeTitleNi(event) {
    if (event.target.value > 100) {
      this.setState({ fontSize_titleNi: 5 });
    } else if (event.target.value < 15) {
      this.setState({ fontSize_titleNi: 15 });
    } else {
      this.setState({ fontSize_titleNi: event.target.value });
    }
  }

  //Change Font SIZE Title 2
  handleChangeFontSizeTitleSec(event) {
    if (event.target.value > 50) {
      this.setState({ fontSize_titleSec: 50 });
    } else if (event.target.value < 25) {
      this.setState({ fontSize_titleSec: 25 });
    } else {
      this.setState({ fontSize_titleSec: event.target.value });
    }
  }

  //Change Font SIZE Title 2 no image
  handleChangeFontSizeTitleSecNi(event) {
    if (event.target.value > 55) {
      this.setState({ fontSize_titleSecNi: 55 });
    } else if (event.target.value < 30) {
      this.setState({ fontSize_titleSecNi: 30 });
    } else {
      this.setState({ fontSize_titleSecNi: event.target.value });
    }
  }

  // DESCRIPTION
  //Change Font SIZE Description
  handleChangeFontSizeDescription(event) {
    if (event.target.value > 30) {
      this.setState({ fontSize_description: 30 });
    } else if (event.target.value < 20) {
      this.setState({ fontSize_description: 20 });
    } else {
      this.setState({ fontSize_description: event.target.value });
    }
  }

  //Change Font SIZE Description No image
  handleChangeFontSizeDescriptionNi(event) {
    if (event.target.value > 33) {
      this.setState({ fontSize_descriptionNi: 33 });
    } else if (event.target.value < 22) {
      this.setState({ fontSize_descriptionNi: 2 });
    } else {
      this.setState({ fontSize_descriptionNi: event.target.value });
    }
  }

  //Change Font SIZE Description 2
  handleChangeFontSizeDescriptionSec(event) {
    if (event.target.value > 30) {
      this.setState({ fontSize_descriptionSec: 30 });
    } else if (event.target.value < 20) {
      this.setState({ fontSize_descriptionSec: 20 });
    } else {
      this.setState({ fontSize_descriptionSec: event.target.value });
    }
  }

  //Change Font SIZE Description 2 No image
  handleChangeFontSizeDescriptionSecNi(event) {
    if (event.target.value > 33) {
      this.setState({ fontSize_descriptionSecNi: 33 });
    } else if (event.target.value < 22) {
      this.setState({ fontSize_descriptionSecNi: 22 });
    } else {
      this.setState({ fontSize_descriptionSecNi: event.target.value });
    }
  }

  // Origin SIZE
  //Change Font SIZE Origin
  handleChangeFontSizeOrigin(event) {
    if (event.target.value > 40) {
      this.setState({ fontSize_origin: 40 });
    } else if (event.target.value < 20) {
      this.setState({ fontSize_origin: 20 });
    } else {
      this.setState({ fontSize_origin: event.target.value });
    }
  }

  // Calories SIZE
  //Change Font SIZE Calories
  handleChangeFontSizeCalories(event) {
    if (event.target.value > 40) {
      this.setState({ fontSize_calories: 40 });
    } else if (event.target.value < 15) {
      this.setState({ fontSize_calories: 15 });
    } else {
      this.setState({ fontSize_calories: event.target.value });
    }
  }

  // PRICE
  //Change Font SIZE PRICE
  handleChangeFontSizePrice(event) {
    if (event.target.value > 100) {
      this.setState({ fontSize_price: 100 });
    } else if (event.target.value < 20) {
      this.setState({ fontSize_price: 20 });
    } else {
      this.setState({ fontSize_price: event.target.value });
    }
  }

  //Change Font Family Price
  handleChangeFontFamilyPrice(event) {
    this.setState({ fontFamily_price: event.target.value });
  }

  //Cahnge Color PRICE Text
  handleChangeColorPriceTxt(event) {
    this.setState({ color_priceTx: event.target.value });
  }
  //Cahnge Color PRICE Background
  handleChangeColorPriceBg(event) {
    this.setState({ color_priceBg: event.target.value });
  }
    //Change Curved
  handleChangeCurved(event) {
      this.setState({ Curved_tb: event.target.value });

  }
  //Change Index
  handleChangeIndex(event) {
    if (event.target.value > 999) {
      this.setState({ zindex_bg: 999 });
    } else if (event.target.value < 1) {
      this.setState({ zindex_bg: 1 });
    } else {
      this.setState({ zindex_bg: event.target.value });
    }
    this.props.onLayerChange(this.props.item.i, event.target.value);
  }

  //Cancel Changes
  cancelOnModal = () => {
    //COLOR
    //Color background
    this.setState({ color_bg: this.state.color_bg_canc });
    //Primary
    this.setState({ color_primary: this.state.color_primary_canc });
    //Accent
    this.setState({ color_accent: this.state.color_accent_canc });
    //ImageUploaded Header
    this.setState({ headerImage: this.state.headerImage_canc });
    //FONTFAMILY
    //Primary
    this.setState({ fontFamily_primary: this.state.fontFamily_primary_canc });
    //Secondary
    this.setState({
      fontFamily_secondary: this.state.fontFamily_secondary_canc,
      
    });

    //FONTSIZE
    //Title 1
    this.setState({ fontSize_title: this.state.fontSize_title_canc });
    //Title 1 no image
    this.setState({ fontSize_titleNi: this.state.fontSize_titleNi_canc });
    //Title 2
    this.setState({ fontSize_titleSec: this.state.fontSize_titleSec_canc });
    //Title 2 No image
    this.setState({ fontSize_titleSecNi: this.state.fontSize_titleSecNi_canc });

    //Description 1
    this.setState({
      fontSize_description: this.state.fontSize_description_canc,
    });
    //Description 1 No image
    this.setState({
      fontSize_descriptionNi: this.state.fontSize_descriptionNi_canc,
    });
    //Description 2
    this.setState({
      fontSize_descriptionSec: this.state.fontSize_descriptionSec_canc,
    });
    //Description 2  No image
    this.setState({
      fontSize_descriptionSecNi: this.state.fontSize_descriptionSecNi_canc,
    });
    
    this.setState({ Curved_tb: this.state.Curved_tb_canc });
    //Z index
    this.setState({ zindex_bg: this.state.zindex_bg_canc });
    // this.props.onLayerChange(this.props.item.i, this.state.zindex_bg_canc);
    this.setState({switchDiamondbackground: this.state.switchDiamondbackground_canc});
    this.setState({switchSplitStyle: this.state.switchSplitStyle_canc});
    this.handleCloseModify();
  };

  //Confirm Changes
  confirmChangeonModal = () => {
    //COLOR
    //Color background
    this.setState({ color_bg_canc: this.state.color_bg });
    this.props.item.background = this.state.color_bg;
    //Primary
    this.setState({ color_primary_canc: this.state.color_primary });
    this.props.item.colorPrimary = this.state.color_primary;
    //ImageUploaded Header
    this.setState({ headerImage_canc: this.state.headerImage });
    this.props.item.headerImage = this.state.headerImage;
    //console.log(this.state.headerImage)
    //Accent
    this.setState({
      color_accent_canc: this.state.color_accent,
    });
    this.props.item.colorAccent = this.state.color_accent;
    this.setState({ borderRadius_canc: this.state.borderRadius });
    //FONTFAMILY
    //Primary
    this.setState({ fontFamily_primary_canc: this.state.fontFamily_primary });
    this.props.item.fontFamily = this.state.fontFamily_primary;
    //Secondary
    this.setState({
      fontFamily_secondary_canc: this.state.fontFamily_secondary,
    });
    this.props.item.fontFamilySecondary = this.state.fontFamily_secondary;

    //FONTSIZE
    //Title 1
    this.setState({ fontSize_title_canc: this.state.fontSize_title });
    this.props.item.fontSizeTitle = this.state.fontSize_title;
    //Title 1 no image
    this.setState({ fontSize_titleNi_canc: this.state.fontSize_titleNi });
    this.props.item.fontSizeTitleNi = this.state.fontSize_titleNi;
    //Title 2
    this.setState({ fontSize_titleSec_canc: this.state.fontSize_titleSec });
    this.props.item.fontSizeTitleSec = this.state.fontSize_titleSec;
    //Title 2 No image
    this.setState({ fontSize_titleSecNi_canc: this.state.fontSize_titleSecNi });
    this.props.item.fontSizeTitleSecNi = this.state.fontSize_titleSecNi;
    this.props.item.borderRadius = this.state.Curved_tb;
    //Description 1
    this.setState({
      fontSize_description_canc: this.state.fontSize_description,
    });
    this.props.item.fontSizeDescription = this.state.fontSize_description;
    //Description 1 No image
    this.setState({
      fontSize_descriptionNi_canc: this.state.fontSize_descriptionNi,
    });

    this.props.item.fontSizeDescriptionNi = this.state.fontSize_descriptionNi;
    //Description 2
    this.setState({
      fontSize_descriptionSec_canc: this.state.fontSize_descriptionSec,
    });
    this.props.item.fontSizeDescriptionSec = this.state.fontSize_descriptionSec;
    //Description 2  No image
    this.setState({
      fontSize_descriptionSecNi_canc: this.state.fontSize_descriptionSecNi,
    });
    this.props.item.fontSizeDescriptionSecNi = this.state.fontSize_descriptionSecNi;
    //Price
    this.setState({
      color_priceBg_canc: this.state.color_priceBg,
    });
    this.props.item.colorPrice = this.state.color_priceBg;
    this.setState({
      color_priceTx_canc: this.state.color_priceTx,
    });
    this.props.item.colorPriceTx = this.state.color_priceTx;
    this.setState({
      fontSize_price_canc: this.state.fontSize_price,
    });
    this.props.item.fontSizePrice = this.state.fontSize_price;
    this.setState({
      fontFamily_price_canc: this.state.fontFamily_price,
    });
    this.props.item.fontFamilyPrice = this.state.fontFamily_price;

    //Origin
    this.setState({
      fontSize_origin_canc: this.state.fontSize_origin,
    });
    this.props.item.fontSizeOrigin = this.state.fontSize_origin;

    //Calories
    this.setState({
      fontSize_calories_canc: this.state.fontSize_calories,
    });
    this.props.item.fontSizeCalories = this.state.fontSize_calories;

    //Z-index
    this.setState({ zindex_bg_canc: this.state.zindex_bg });

    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    //this.props.item.typeSize = this.state.type_size;

    this.setState({ id_foodgroup_canc: this.state.id_foodgroup });
    this.props.item.id = this.state.id_foodgroup;

    this.setState({ switchDiamondbackground_canc:  this.state.switchDiamondbackground});
    this.props.item.switchDiamondbackground=this.state.switchDiamondbackground;

    this.setState({ switchSplitStyle_canc:  this.state.switchSplitStyle});
    this.state.switchSplitStyle=this.state.switchSplitStyle;

    this.props.onStyleChange(this.props.item);
    this.handleCloseModify();
  };

  //Cahnge SIZE
  changeSize_1 = () => {
    this.setState({ height_size: 96 });
    this.setState({ width_size: 192 });
    this.setState({ type_size: 1 });
    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    this.props.item.typeSize = this.state.type_size;

    this.confirmChangeonModal();
    this.props.onFoodGroupLandSizeChange(this.props.item, 192, 96, 1);
  };
  changeSize_2 = () => {
    this.setState({ height_size: 96 });
    this.setState({ width_size: 96 });
    this.setState({ type_size: 2 });
    this.props.item.typeSize = this.state.type_size;
    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    this.props.item.typeSize = this.state.type_size;
    this.confirmChangeonModal();
    this.props.onFoodGroupLandSizeChange(this.props.item, 96, 96, 2);
  };

  changeSize_3 = () => {
    this.setState({ height_size: 96 });
    this.setState({ width_size: 64 });
    this.setState({ type_size: 3 });
    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    this.props.item.typeSize = this.state.type_size;
    this.confirmChangeonModal();
    this.props.onFoodGroupLandSizeChange(this.props.item, 64, 96, 3);
  };
  changeSize_4 = () => {
    this.setState({ height_size: 48 });
    this.setState({ width_size: 96 });
    this.setState({ type_size: 4 });
    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    this.props.item.typeSize = this.state.type_size;

    this.confirmChangeonModal();
    this.props.onFoodGroupLandSizeChange(this.props.item, 96, 48, 4);
  };

  changeSize_5 = () => {
    this.setState({ height_size: 48 });
    this.setState({ width_size: 192 });
    this.setState({ type_size: 5 });
    this.props.item.widthSize = this.state.width_size;
    this.props.item.heightSize = this.state.height_size;
    this.props.item.typeSize = this.state.type_size;

    this.confirmChangeonModal();
    this.props.onFoodGroupLandSizeChange(this.props.item, 192, 48, 5);
  };
  /*handleChangeWidth(event)
  {
   // { Curved_tb: event.target.value } 
   //this.setState({ height_size: 48 });
   this.setState({ width_size: event.target.value });
   //this.setState({ type_size: 5 });
   this.props.item.widthSize = event.target.value//this.state.width_size;
   //this.props.item.heightSize = this.state.height_size;
   //this.props.item.typeSize = this.state.type_size;

   this.confirmChangeonModal();
   this.props.onFoodGroupLandSizeChange(this.props.item, this.props.item.widthSize, this.props.item.heightSize, 5);
  }
  handleChangeHeight(event)
  {
  
   // { Height_tb: event.target.value } 
   this.setState({ height_size: event.target.value });
   //this.setState({ width_size: 192 });
   //this.setState({ type_size: 5 });
   //this.props.item.widthSize = this.state.width_size;
    
   this.props.item.heightSize = event.target.value//this.state.height_size;
   //this.props.item.typeSize = this.state.type_size;
   //alert()
   //alert(this.state.height_size);
   //this.confirmChangeonModal();
   //this.props.onFoodGroupLandSizeChange(this.props.item, 192, 48, 5);
   this.props.onFoodGroupLandSizeChange(this.props.item, this.props.item.widthSize, this.props.item.heightSize, 5);
  }*/
  //Change ID ZONE
  handleChangeIDFoodgroup(event) {
    this.setState({ id_foodgroup: event.target.value });
  }

  //get MAP FROM DISPLAY ID
  getFoodItems = () => {
    this.setState({ foodgroup: [] });
    this.setState({ foodgroup_validation: "" });
    getfooditemsbyfoodgroupID(this.state.id_foodgroup).then((res) => {
      if (res == null) {
        this.setState({ foodgroup: [] });
        this.setState({ foodgroup_validation: "Food Group empty" });
      } else if (res[0]) {
        //alert(res[0]);
       // console.log(res[0]);
       this.setState({ foodgroup: res });
      //alert(this.foodgroup.);
       this.setState({ foodgroup_validation: "" });
      } else {
        this.setState({ foodgroup: [] });
        this.setState({ foodgroup_validation: "l'iD zone don't exist" });
      }
    });
  };

  //get Icon Allergens
  getIconSvg(allergen) {
    let allergenIcon = allergen
      .split(" ")
      .join("")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    if (allergen) {
      const svgIndex = "Svg" + allergenIcon;
      return allergensIcons[svgIndex];
    }
    return null;
  }

  //get WIDTH FLEX
  getwidthItems() {
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let flex = " 33%";
    if (this.state.switchDiamondbackground === true) {
      switch (activeFoodItem) {
        case 1:
          flex = "1237.39px";
          //heightItems = "90%";
          break;
        case 2:
          flex = "887px";
         // heightItems = "40.0%";
          break;
        case 3:
          flex = "887px";
         // heightItems = "26.67%";
          break;
        case 4:
          flex = "887px";
           // heightItems = "20%";
            break;
        case 5:
          flex = "887px";
           // heightItems = "16%";
            break;
        default:
          flex = "887px";
      }
     
     
    
    } else {
       flex = " 25%";
       if (this.state.type_size === 1) {
          if (activeFoodItem > 6) {
           flex = " 20%";
         } else if (activeFoodItem <= 4) {
        flex = " 40%";
         } else if (activeFoodItem <= 6) {
        flex = " 30%";
          }
    } else if (this.state.type_size === 2) {
      if (activeFoodItem > 2) {
        flex = " 40%";
      } else if (activeFoodItem <= 2) {
        flex = " 55%";
      }
    } else if (this.state.type_size === 3) {
      flex = " 95%";
    } else if (this.state.type_size === 4) {
      flex = " 40%";
    } else if (this.state.type_size === 5) {
      flex = " 10%";
    }
  }
    return flex;
  }

  //get max number of Food item
  //get max number of Food item
  getmaxFoodItem() {
    let slice = 8;
    if (this.state.switchDiamondbackground === true) {
      if (this.state.type_size === 1) {
        slice = 8;
      } else if (this.state.type_size === 2) {
        slice = 5;
      } else if (this.state.type_size === 3) {
        slice = 5;
      } else if (this.state.type_size === 4) {
        slice = 5;
      } else if (this.state.type_size === 5) {
        slice = 5;
      } 
  }
  else 
  {
    if (this.state.type_size === 1) {
      slice = 8;
    } else if (this.state.type_size === 2) {
      slice = 4;
    } else if (this.state.type_size === 3) {
      slice = 2;
    } else if (this.state.type_size === 4) {
      slice = 2;
    } else if (this.state.type_size === 5) {
      slice = 4;
    }
  }
    return slice;
  }



  getHeightItems() {
    let activeFoodItem =
      this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;
     
      let heightItems = "400px";
    if (this.state.switchDiamondbackground == true) {
      //console.log("Diamond height");
    //  console.log(activeFoodItem);
        switch (activeFoodItem) {
          case 1:
            heightItems = "340px";
            //heightItems = "90%";
            break;
          case 2:
            heightItems = "277px";
           // heightItems = "40.0%";
            break;
          case 3:
            heightItems = "201px";
           // heightItems = "26.67%";
            break;
          case 4:
            heightItems = "180px";
             // heightItems = "20%";
              break;
          case 5:
             heightItems = "150px";
             // heightItems = "16%";
              break;
          default:
           heightItems = "150px";
        }

      } else {
           if (this.state.type_size === 1 && activeFoodItem <= 2) {
            heightItems="85%"
           }
           else { heightItems ="400px" }
      }
      
      return heightItems
  }

  getMaxWidthItems() {
    let activeFoodItem =
      this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;

    if (this.state.type_size === 1) {
      if (activeFoodItem === 3) {
        return " calc(50% - 60px)";
      } else {
        return " auto";
      }
    }
  }


  getImageUploaded = (ImageUploaded) => {
    this.setState({ headerImage: ImageUploaded })
  }


  //Capitalize
  capitalize(s) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
  }
  borderRadiusContainer() {
    //alert(this.state.Curved_tb);
    //console.log("borderRadiusContainer")
    //console.log(this.props.item.widthSize);
   // console.log(this.state.width_size);
    if (this.state.Curved_tb===undefined)
    {
      this.state.Curved_tb=0
     }
      let borderRadiusContainer = this.state.Curved_tb;
        return borderRadiusContainer;
  }
  GetVerticalLineMargin() {
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let VerticalLineMargin = "75";
    //console.log("widthSize");
   // console.log(this.props.item.widthSize);
    if (this.state.switchDiamondbackground === true) {
      switch (activeFoodItem) {
        case 1:
          if (this.props.item.widthSize<100)
            {
              VerticalLineMargin= "83.5";
             }
             else
             {
              VerticalLineMargin =  "82.5";
             }
          
          
          break;
        case 2:
             if (this.props.item.widthSize<100)
            {
              VerticalLineMargin= "83.5";
             }
             else
             {
              VerticalLineMargin =  "83.5";
             }
          break;
        case 3:
              if (this.props.item.widthSize<100)
                {
                  VerticalLineMargin= "83.5";
                 }
                 else
                 {
                  VerticalLineMargin =  "83.5";
                 }
          break;
        case 4:
          if (this.props.item.widthSize<100)
            {
              VerticalLineMargin= "85.5";
             }
             else
             {
              VerticalLineMargin =  "83.5";
             }
            break;
        case 5:
          if (this.props.item.widthSize<100)
            {
              VerticalLineMargin= "85.5";
             }
             else
             {
              VerticalLineMargin =  "83.5";
             }
            break;
        default:
          VerticalLineMargin =  "83.5";
        
    }
  } else {
    VerticalLineMargin =  "83.5";
  }
  //console.log("VerticalLineMargin");
 // console.log(VerticalLineMargin);
  return VerticalLineMargin;
    //alert(this.state.Curved_tb);
    //if (this.props.item.widthSize<100)
   // {
   //   return "78";
  //   }
  //   else
   //  {return "83.5";}

       
  }
  GetVerticalLineHeight() {
    //alert(this.state.Curved_tb);

      //alert(this.state.Curved_tb);
      let activeFoodItem = this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;  
      let VerticalLineHeight = "75";
      //console.log("widthSize");
     // console.log(this.props.item.widthSize);
      if (this.state.switchDiamondbackground === true) {
        switch (activeFoodItem) {
          case 1:
            if (this.props.item.widthSize<100)
              {
                VerticalLineHeight= "75";
               }
               else
               {
                VerticalLineHeight =  "75";
               }
            
            
            break;
          case 2:
            if (this.props.item.widthSize<100)
              {
                VerticalLineHeight= "75";
               }
               else
               {
                VerticalLineHeight =  "75";
               }
            break;
          case 3:
            if (this.props.item.widthSize<100)
              {
                VerticalLineHeight= "65";
               }
               else
               {
                VerticalLineHeight =  "75";
               }
            break;
          case 4:
            if (this.props.item.widthSize<100)
              {
                VerticalLineHeight= "65";
               }
               else
               {
                VerticalLineHeight =  "75";
               }
              break;
          case 5:
            if (this.props.item.widthSize<100)
              {
                VerticalLineHeight= "65";
               }
               else
               {
                VerticalLineHeight =  "75";
               }
              break;
          default:
            VerticalLineHeight =  "75";
          
      }
    } else {
      VerticalLineHeight =  "75";
    }
    //console.log("VerticalLineHeight");
  //  console.log(VerticalLineHeight);
    return VerticalLineHeight;

   // if (this.props.item.widthSize<100)
  //  {
   //   return "75";
   //  }
   //  else
   //  {return "75";}

       
  }
  GetVerticalLineMarginTop() {
    //alert(this.state.Curved_tb);
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let MarginTop = "30";
    console.log("VerticalLineMarginTop W");
    console.log(this.props.item.w);
    console.log(this.props.item.maxW);
    if (this.state.switchDiamondbackground === true) {
      switch (activeFoodItem) {
        case 1:
          if (this.props.item.widthSize<100)
            {
              MarginTop= "2.5";
             }
             else
             {
              MarginTop =  "2.5";
             }
          
          
          break;
        case 2:
          if (this.props.item.widthSize<100)
            {
              MarginTop= "2.5";
             }
             else
             {
              MarginTop =  "0.5";
             }
          break;
        case 3:
          if (this.props.item.widthSize<100)
            {
              MarginTop= "2.5";
             }
             else
             {
              MarginTop =  "0.5";
             }
          break;
        case 4:
          if (this.props.item.widthSize<100)
            {
              MarginTop= "2.5";
             }
             else
             {
              MarginTop =  "0.5";
             }
            break;
        case 5:
          if (this.props.item.widthSize<100)
            {
              MarginTop= "2.3";
             }
             else
             {
              MarginTop =  "0.5";
             }
            break;
        default:
          MarginTop =  "2.3";
        
    }
  } else {
    MarginTop =  "1";
  }
 // console.log("MarginTop");
//  console.log(MarginTop);
  return MarginTop;
   /* if (this.props.item.widthSize<100)
    {
      return "3";
     }
     else
     {return "1";}*/

       
  }
  GetBorderStyleAllergen() {
    //alert(this.state.Curved_tb);
    if (this.state.switchDiamondbackground === false)
    {
      return "tagImageStyle";
     }
     else
     {return "tagImageStyle_AGR";}

       
  }
  tagImageStyleMargin(){
    console.log("tagImageStyleMargin");
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let ImageStyleMargin = " -15px 3px";
    if (this.state.switchSplitStyle===true)
    {
      switch (activeFoodItem) {
        case 1:
          ImageStyleMargin =  "-15px 3px";//
          
          break;
        case 2:
          ImageStyleMargin =  "-15px 3px";//" 15px 30px";
         // heightItems = "40.0%";
          break;
        case 3:
          ImageStyleMargin =  "0px 3px";//" 15px 30px";
         // heightItems = "26.67%";
          break;
        case 4:
          ImageStyleMargin =  "10px 3px";//" 15px 30px";
           // heightItems = "20%";
            break;
        case 5:
          ImageStyleMargin =  "15px 3px";//"15px 30px";
           // heightItems = "16%";
            break;
        default:
          ImageStyleMargin =  "15px 3px";
      } 
    }
    else
    {
      switch (activeFoodItem) {
        case 1:
          ImageStyleMargin =  "-15px 3px";//
          
          break;
        case 2:
          ImageStyleMargin =  "-15px 3px";//" 15px 30px";
         // heightItems = "40.0%";
          break;
        case 3:
          ImageStyleMargin =  "-15px 3px";//" 15px 30px";
         // heightItems = "26.67%";
          break;
        case 4:
          ImageStyleMargin =  "-15px 3px";//" 15px 30px";
           // heightItems = "20%";
            break;
        case 5:
          ImageStyleMargin =  "-15px 3px";//"15px 30px";
           // heightItems = "16%";
            break;
        default:
          ImageStyleMargin =  "-15px 3px";
    }
  }
    return ImageStyleMargin;

  }

  
  tagImageStyleSize(){
    console.log("tagImageStyleSize");
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let ImageStyleSize = " 75px";
    
    if (this.state.switchSplitStyle===true)
    {
      switch (activeFoodItem) {
        case 1:
          ImageStyleSize =  "75px";//
          
          break;
        case 2:
          ImageStyleSize =  "75px";//" 15px 30px";
         // heightItems = "40.0%";
          break;
        case 3:
          ImageStyleSize =  "70px";//" 15px 30px";
         // heightItems = "26.67%";
          break;
        case 4:
          ImageStyleSize =  "65px";//" 15px 30px";
           // heightItems = "20%";
            break;
        case 5:
          ImageStyleSize =  "55px";//"15px 30px";
           // heightItems = "16%";
            break;
        default:
          ImageStyleSize =  "55px";
        
    }
  }
    else
    {
      switch (activeFoodItem) {
        case 1:
          ImageStyleSize =  "75px";//
          
          break;
        case 2:
          ImageStyleSize =  "75px";//" 15px 30px";
         // heightItems = "40.0%";
          break;
        case 3:
          ImageStyleSize =  "75px";//" 15px 30px";
         // heightItems = "26.67%";
          break;
        case 4:
          ImageStyleSize =  "75px";//" 15px 30px";
           // heightItems = "20%";
            break;
        case 5:
          ImageStyleSize =  "75px";//"15px 30px";
           // heightItems = "16%";
            break;
        default:
          ImageStyleSize =  "75px";
    }
  }
 
return ImageStyleSize;


  }
  
  getContainerLibraryRight() {
    //alert(this.state.Curved_tb);
    let activeFoodItem = this.state.foodgroup.filter(function (value) {
      return value.active !== false;
    }).length;  
    let ContainerLibraryRight = " auto 30px";
  //  console.log(activeFoodItem);
    if (this.state.switchDiamondbackground === true) {
      switch (activeFoodItem) {
        case 1:
          ContainerLibraryRight =  "3";//
          
          break;
        case 2:
          if (this.state.switchSplitStyle===true)
            {
              ContainerLibraryRight =  "0";//" 15px 30px";
            }
          else
          {
              ContainerLibraryRight =  "3";//" 15px 30px";
            }
          //ContainerLibraryRight =  "3";//" 15px 30px";
         // heightItems = "40.0%";
          break;
        case 3:
          if (this.state.switchSplitStyle===true)
            {
              ContainerLibraryRight =  "1";//" 15px 30px";
            }
          else
          {
              ContainerLibraryRight =  "3";//" 15px 30px";
            }
          
         // heightItems = "26.67%";
          break;
        case 4:
          if (this.state.switchSplitStyle===true)
            {
              ContainerLibraryRight =  "-1";//" 15px 30px";
            }
          else
          {
              ContainerLibraryRight =  "1.1";//" 15px 30px";
            }
          
           // heightItems = "20%";
            break;
        case 5:
          ContainerLibraryRight =  "1.5";//"15px 30px";
           // heightItems = "16%";
            break;
        default:
          ContainerLibraryRight =  "1.5";
        
    }
  } else {
    ContainerLibraryRight =  "3";
  }
  //console.log("FoodStyleMarginItems");
//  console.log(FoodStyleMarginItems);
  return ContainerLibraryRight;
 /*   if (this.props.item.widthSize<100)
    if (this.props.item.widthSize<100)
      {
        return "105";
       }
       else
       {return "125";}*/

       
  }
  GetPriceAdjustment(PriceValue,CurrencyValue) {
    //alert(this.state.Curved_tb);
    console.log("GetPriceAdjustment")
    console.log(PriceValue);
    console.log(CurrencyValue);
    if (CurrencyValue === " " ||
      CurrencyValue === "" ||
      CurrencyValue === "EUR" ||
      CurrencyValue === "Eur" ||
      CurrencyValue === "eur" ||
      CurrencyValue === "Euro")
      {
        PriceValue= Number(Math.round(parseFloat(PriceValue + 'e' + 2)) + 'e-' + 2).toFixed(2)
      }
      console.log(PriceValue);
   // if (this.state.switchDiamondbackground === true && PriceValue < 10)
   // {
   //   return " " + PriceValue;
   //  }
   //  else
   //  {return PriceValue;}
    return PriceValue;
       
  }

  GetPricesStyle2(CurrencyValue) {
    //alert(this.state.Curved_tb);
   /* const styles = {

      AGR_h6:"pricesStyle_AGR_h6",
      nonAGR: "pricesStyle",
      AGR_h6_euro: "pricesStyle_AGR_h6_euro"
  };*/



    console.log("GetPricesStyle");
    console.log(this.state.switchDiamondbackground);  
    console.log(CurrencyValue);
    if (this.state.switchDiamondbackground === true && CurrencyValue ==='Pts')
    {
      return  "1.1rem";//styles["AGR_h6"] || "default-style";
     }
     else
     {
     if(CurrencyValue === " " ||
      CurrencyValue === "" ||
      CurrencyValue === "EUR" ||
      CurrencyValue === "Eur" ||
      CurrencyValue === "eur" ||
      CurrencyValue === "Euro" )
     {
      /*let activeFoodItem = this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;  
      let FoodStyleCurrency = " 3.1rem";
    //  console.log(activeFoodItem);
        switch (activeFoodItem) {
          case 1:
            FoodStyleCurrency =  " 3.1rem";//
            
            break;
          case 2:
            FoodStyleCurrency =  " 3.1rem";//" 15px 30px";
           // heightItems = "40.0%";
            break;
          case 3:
            FoodStyleCurrency =  " 3.1rem";//" 15px 30px";
           // heightItems = "26.67%";
            break;
          case 4:
            FoodStyleCurrency =  " 3.1rem";//" 15px 30px";
             // heightItems = "20%";
              break;
          case 5:
            FoodStyleCurrency =  " 3.1rem";//"15px 30px";
             // heightItems = "16%";
              break;
          default:
            FoodStyleCurrency =  " 3.1rem";
          
      }*/
     let FoodStyleCurrency =  this.getFontAdjustment(this.state.fontSize_price)+ "px";//styles["AGR_h6"] || "default-style";
       if (this.state.switchDiamondbackground === true)
        {
          FoodStyleCurrency= "2.1rem";
        }
     return    FoodStyleCurrency;//styles["nonAGR"] || "default-style";
    
     }else
     {
      return    "1.1rem";//styles["AGR_h6_euro"] || "default-style";
   
     }

    }
    
     return "";//(this.state.fontSize_price *0.33) + "px";
       
  }
  getFoodStyleMarginItems() {
      //alert(this.state.Curved_tb);
      let activeFoodItem = this.state.foodgroup.filter(function (value) {
        return value.active !== false;
      }).length;  
      let FoodStyleMarginItems = " auto 30px";
    //  console.log(activeFoodItem);
      if (this.state.switchDiamondbackground === true) {
        switch (activeFoodItem) {
          case 1:
            FoodStyleMarginItems =  " auto 30px";//
            
            break;
          case 2:
            FoodStyleMarginItems =  " auto 30px";//" 15px 30px";
           // heightItems = "40.0%";
            break;
          case 3:
            FoodStyleMarginItems =  " auto 30px";//" 15px 30px";
           // heightItems = "26.67%";
            break;
          case 4:
            FoodStyleMarginItems =  " auto 30px";//" 15px 30px";
             // heightItems = "20%";
              break;
          case 5:
            FoodStyleMarginItems =  " auto 30px";//"15px 30px";
             // heightItems = "16%";
              break;
          default:
            FoodStyleMarginItems =  " auto 30px";
          
      }
    } else {
      FoodStyleMarginItems =  " auto 30px";
    }
    //console.log("FoodStyleMarginItems");
  //  console.log(FoodStyleMarginItems);
    return FoodStyleMarginItems;
   /*   if (this.props.item.widthSize<100)
      {
      return " auto 30px";//" 15px 30px";
    } else {
      return " 15px 30px";
    }*/
 // }
  }

 getHexagonStyleBottomMargin() {

  let activeFoodItem = this.state.foodgroup.filter(function (value) {
    return value.active !== false;
  }).length;  
  let BottomMargin = "30";
 // console.log(activeFoodItem);
/*  if (this.state.switchDiamondbackground === true) {
    switch (activeFoodItem) {
      case 1:
        BottomMargin =  "30";
        
        break;
      case 2:
        BottomMargin =  "27";
       // heightItems = "40.0%";
        break;
      case 3:
        BottomMargin =  "15";
       // heightItems = "26.67%";
        break;
      case 4:
        BottomMargin =  "9";
         // heightItems = "20%";
          break;
      case 5:
        BottomMargin =  "1.5";
         // heightItems = "16%";
          break;
      default:
        BottomMargin =  "30";
      
  }
} else {
  BottomMargin =  "30";
}*/
if (this.state.switchDiamondbackground === true) {
  if (this.state.switchSplitStyle===true)
    {
      switch (activeFoodItem) {
        case 1:
          BottomMargin =  "30";
          
          break;
        case 2:
          BottomMargin =  "25";
          //BottomMargin =  "27";
         // heightItems = "40.0%";
          break;
        case 3:
          BottomMargin =  "15";
         // heightItems = "26.67%";
          break;
        case 4:
          BottomMargin =  "15";
           // heightItems = "20%";
            break;
        case 5:
          BottomMargin =  "5";
           // heightItems = "16%";
            break;
        default:
          BottomMargin =  "5";
      }
    }
  else
  {
    switch (activeFoodItem) {
      case 1:
        BottomMargin =  "25";
        
        break;
      case 2:
        BottomMargin =  "20";
        //BottomMargin =  "27";
       // heightItems = "40.0%";
        break;
      case 3:
        BottomMargin =  "10";
       // heightItems = "26.67%";
        break;
      case 4:
        BottomMargin =  "15";
         // heightItems = "20%";
          break;
      case 5:
        BottomMargin =  "5";
         // heightItems = "16%";
          break;
      default:
        BottomMargin =  "30";
      /*case 1:
        BottomMargin =  "30";
        
        break;
      case 2:
        BottomMargin =  "20";
       // heightItems = "40.0%";
        break;
      case 3:
        BottomMargin =  "13";
       // heightItems = "26.67%";
        break;
      case 4:
        BottomMargin =  "9";
         // heightItems = "20%";
          break;
      case 5:
        BottomMargin =  "6";
         // heightItems = "16%";
          break;
      default:
        BottomMargin =  "30";*/
    }
      
  }
  }else {
    BottomMargin =  "30";
}
//console.log("BottomMargin");
//console.log(BottomMargin);
return BottomMargin;
 }

 

 containerPricesStyleRight() {

  let activeFoodItem = this.state.foodgroup.filter(function (value) {
    return value.active !== false;
  }).length;  
  let PricesStyleRight = "35px";
  //console.log(activeFoodItem);
  if (this.state.switchDiamondbackground === true) {
    if (this.state.switchSplitStyle===false)
      {
        switch (activeFoodItem) {
          case 1:
            PricesStyleRight =  "4.5%";
            
            break;
          case 2:
            PricesStyleRight =  "4.5%";
           // heightItems = "40.0%";
            break;
          case 3:
            PricesStyleRight =  "4%";
           // heightItems = "26.67%";
            break;
          case 4:
            PricesStyleRight =  "3.5%";
             // heightItems = "20%";
              break;
          case 5:
            PricesStyleRight =  "4.5%";
             // heightItems = "16%";
              break;
          default:
            PricesStyleRight =  "4.5%";
        }
      }
    else
    {
      switch (activeFoodItem) {
        case 1:
          //PricesStyleRight =  "1.8%";
          PricesStyleRight =  "2.2%";
          break;
        case 2:
          PricesStyleRight =  "2.1%";
          //PricesStyleRight =  "2.1%";
         // heightItems = "40.0%";
          break;
        case 3:
          PricesStyleRight =  "2.5%";
         // PricesStyleRight =  "2.8%";
         // heightItems = "26.67%";
          break;
        case 4:
          PricesStyleRight =  "2.3%";
          //PricesStyleRight =  "2.5%";
           // heightItems = "20%";
            break;
        case 5:
          PricesStyleRight =  "3.5%";
          //PricesStyleRight =  "3.5%";
           // heightItems = "16%";
            break;
        default:
          PricesStyleRight =  "2.5%";
      }
        
    }
  }

     else {
  PricesStyleRight =  "35px";
  }

//console.log("PricesStyleRight");
//console.log(PricesStyleRight);
return PricesStyleRight;
 }

 getHexagonStylePadding() {

  let activeFoodItem = this.state.foodgroup.filter(function (value) {
    return value.active !== false;
  }).length;  
  let HexagonPadding = "35";
 // console.log(activeFoodItem);
  if (this.state.switchDiamondbackground === true) {
    switch (activeFoodItem) {
      case 1:
        if (this.state.switchSplitStyle===true)
        {
          HexagonPadding =  "3.5%";
        }
        else
        {
        HexagonPadding =  "2.3%";
        }
        break;
      case 2:
        if (this.state.switchSplitStyle===true)
        {
          HexagonPadding =  "3.5%";
        }
        else
        {
          HexagonPadding =  "2.3%";
        }
        //HexagonPadding =  "35px";
        
       // heightItems = "40.0%";
        break;
      case 3:
        if (this.state.switchSplitStyle===true)
          {
            HexagonPadding =  "3.3%";
          }
          else
          {
            HexagonPadding =  "2%";
          }
        //HexagonPadding =  "28px";
      
       // heightItems = "26.67%";
        break;
      case 4:
        if (this.state.switchSplitStyle===true)
          {
            HexagonPadding =  "2.3%";
          }
          else
          {
            HexagonPadding =  "1.3%";
          }
        //HexagonPadding =  "28px";
       
         // heightItems = "20%";
          break;
      case 5:
        if (this.state.switchSplitStyle===true)
          {
            HexagonPadding =  "2.3%";
          }
          else
          {
            HexagonPadding =  "1.3%";
          }
     
        //HexagonPadding =  "15px";
         
          break;
      default:
        if (this.state.switchSplitStyle===true)
          {
            HexagonPadding =  "2.3%";
          }
          else
          {
            HexagonPadding =  "1.3%";
          }
        //HexagonPadding =  "35px";
      
  }
} else {
  HexagonPadding =  "35px";
}
//console.log("HexagonPadding");
//console.log(HexagonPadding);
return HexagonPadding;
 }

 getFontAdjustment(myfontsize) {
  let activeFoodItem = this.state.foodgroup.filter(function (value) {
    return value.active !== false;
  }).length;  
  let fontSize = myfontsize;
  if (this.state.switchDiamondbackground === true) {
    if (this.state.switchSplitStyle===true)
      {
        switch (activeFoodItem) {
          case 1:
            fontSize = myfontsize;
            
            break;
          case 2:
            fontSize = myfontsize;
          // heightItems = "40.0%";
            break;
          case 3:
            fontSize = myfontsize*0.77;
          // heightItems = "26.67%";
            break;
          case 4:
            fontSize = myfontsize*0.70;
            // heightItems = "20%";
              break;
          case 5:
            fontSize = myfontsize*0.60;
            // heightItems = "16%";
              break;
          default:
            fontSize = myfontsize*0.60;
        }
      }
    else
    {
      switch (activeFoodItem) {
        case 1:
          fontSize = myfontsize;
          
          break;
        case 2:
          fontSize = myfontsize;
        // heightItems = "40.0%";
          break;
        case 3:
          fontSize = myfontsize*0.85;
        // heightItems = "26.67%";
          break;
        case 4:
          fontSize = myfontsize*0.70;
          // heightItems = "20%";
            break;
        case 5:
          fontSize = myfontsize*0.60;
          // heightItems = "16%";
            break;
        default:
          fontSize = myfontsize;
      }
        
    }
  }


//console.log("fontSize");
//console.log(fontSize);
return fontSize;
 }

  render() {
    const divStyle = {
      height: "100%",
      width: "100%",
      transition: "all 250ms ease",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      borderRadius: this.borderRadiusContainer() +"px",
    };
    const VerticaldivStyle = {
      //margin: "0",
      borderRight: "2px solid",
      backgroundColor: this.props.item.color,
      //width: "2px",
      height: this.GetVerticalLineHeight() + "%",
     // float:"right",
     marginLeft: this.GetVerticalLineMargin() + "%",
     marginTop: this.GetVerticalLineMarginTop() + "%",
     position:"absolute"
    };



    const containerStyle = {
      padding: "10px",
      backgroundColor: this.state.color_bg,
      height: "100%",
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      borderRadius:this.borderRadiusContainer() +"px",
      //  placeContent: "space-evenly",
      // position:"absolute",
    };




    const foodItemStyle = {
      position: "relative",
      height: this.getHeightItems(),
      backgroundColor: "#FFFFFF",
      padding: "0",
      margin: this.getFoodStyleMarginItems(),//"auto 30px",
      flex: "1 1 " + this.getwidthItems(),
      maxWidth: this.getMaxWidthItems(),
      borderRadius:this.borderRadiusContainer() +"px",

    };


    const originStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.state.fontFamily_secondary,
      color: this.state.color_accent,
      fontSize: this.getFontAdjustment(this.state.fontSize_origin) + "px",
      borderRadius:this.borderRadiusContainer() +"px",
      zIndex: "100",
    };
    const titleStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_title) + "px",
      width:"85%",
      paddingTop: "19px",
    };

    const titleNIStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_titleNi)  + "px",
      width:"85%",
      paddingTop: "19px",
    };
    const titleSecStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_titleSec) + "px",
      width:"85%",
    };
    const titleSecNIStyle = {
      lineHeight: "1.1",
      fontWeight: "bold",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_titleSecNi) + "px",
      width:"85%",
    };

    const descriptionStyle = {
      lineHeight: "1.1",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_description) + "px",
    };

    const descriptionNIStyle = {
      lineHeight: "1.1",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_descriptionNi) + "px",
    };
    const descriptionSecStyle = {
      lineHeight: "1.1",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_descriptionSec) + "px",
    };
    const descriptionSecNIStyle = {
      lineHeight: "1.1",
      fontFamily: this.state.fontFamily_primary,
      color: this.state.color_primary,
      fontSize: this.getFontAdjustment(this.state.fontSize_descriptionSecNi) + "px",
    };
    const containerLabelStyle = {
      position: "relative",
      alignSelf: "flex-end",
      top: "-55px",
      right: "5px",
      display: "flex",
      width: "100%",
      justifyContent: "end",
      height: 0,
    };
    const containerLabelStyle_AGR = {
      position: "relative",
      alignSelf: "flex-end",
      top: "-40px",
      right: this.getContainerLibraryRight() +"%",
      display: "flex",
      //width: "97.5%",
      width: "90.7%",
      justifyContent: "end",
      height: 0,
    };
    const tagImageStyle = {
      backgroundColor: "#F6F6F6",
      borderRadius: "100%",
      objectFit: "cover",
      width: "60px",
      height: "60px",
      float: "left",
      margin: "0 3px",
    };  
    const tagImageStyle_AGR = {
      backgroundColor: "#F6F6F6",
      borderRadius: "100%",
      objectFit: "cover",
      width: this.tagImageStyleSize(),
      height: this.tagImageStyleSize(),
      float: "left",
     // margin: "-25px 3px",
      margin: this.tagImageStyleMargin(),//"-15px 3px",
      borderStyle:"solid",
      borderColor:"#9b223e",
      zIndex: "100",
    };  

    const bodyStyle = {
      flexDirection: "column",
      // flex: "1",
      display: "flex",
      position: "relative",
      width: "100%",
      //height: "100%", ----MB RELEASE

    };
    const bodyStyleNi = {
      flexDirection: "column",
      display: "flex",
      position: "relative",
      width: "100%",
      minHeight: "100%",
      height:"100%",
    };
    const overflowStyle = {
      //overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      padding: "0 8px",
    };
    const allergyContStyle_AGR = {
      display: "block",
      padding: "0% 5px",
      display: "flex",
     // flexWrap: "wrap",
      paddingLeft: 0,
    };
    const allergyContStyle = {
      //display: "block",
      padding: "0 5px",
      display: "flex",
      //flexWrap: "wrap",
      paddingLeft: 0,
    };
    const allergyIconStyle = {
      fill: this.state.color_accent,
      textAlign: "center",
      width: "30px",
      margin: "3px 0",
    };

    const caloriesStyle = {
      marginBottom: "0",
      lineHeight: "1.1",
      color: this.state.color_accent,
      fontSize: this.state.fontSize_calories + "px",
      fontFamily: this.state.fontFamily_secondary,
    };

    const containerPricesStyle = {
      position: "absolute",
      bottom: "110px",
      right: "-20px",
      backgroundColor: this.state.color_priceBg,
      maxWidth: "170px",
      border: "1px solid #fff",
      textAlign: "center",
      padding: "5px",
     
    };
    const containerPricesStyle_agr = {
      position: "absolute",
      bottom: this.getHexagonStyleBottomMargin() +"%" ,
      right: this.containerPricesStyleRight(), //"35px",
     /*top: "35px",*/
      /*backgroundColor: this.state.color_priceBg,*/
      backgroundColor: "lightgrey",
      //maxWidth: "100px",
      border: "1px solid #fff",
      textAlign: "center",
      padding: this.getHexagonStylePadding() ,//+"px",
      //borderRadius:"42px",
     
     
    };
    const containerPricesStyle_agr2 = {
      position: "absolute",
      bottom: this.getHexagonStyleBottomMargin() +"%" ,
      right: "35px",
     /*top: "35px",*/
      backgroundColor: "lightgrey",
      maxWidth: "100px",
      border: "1px solid #fff",
      textAlign: "center",
      padding: "25px",
    //  borderRadius:"42px",
     
     
    };
    const pricesStyle_AGR = {
      marginBottom: 0,
      MarginTop: "10px",
     // padding: "5px",
      textAlign: "center",
       fontFamily: this.state.fontFamily_price,
      color: this.state.color_priceTx,
      fontSize: this.getFontAdjustment(this.state.fontSize_price) + "px",
      fontWeight: "bold",
      position:"relative",

    };
    const pricesStyle_AGR_h6 = (currency) => ({
      marginBottom: 0,
      //MarginTop: "10px",
      //padding: "5px",
      textAlign: "center",
       fontFamily: this.state.fontFamily_price,
      color: this.state.color_priceTx,
      fontSize: this.GetPricesStyle2(currency),//"1.1em",//this.state.fontSize_price + "px",
     // fontWeight: "bold",
     position:"relative",

    });
    
    const pricesStyle = {
      marginBottom: 0,
      padding: "5px",
      textAlign: "center",
      fontFamily: this.state.fontFamily_price,
      color: this.state.color_priceTx,
      fontSize: this.state.fontSize_price + "px",
    };
    const containerfoodItemStyle = {
      height: "100%",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
     // margin: "15px 30px",
      margin: this.getFoodStyleMarginItems(),
    };
    return (
      <>
        <div style={divStyle}>
          <Button
            variant="primary"
            className="circlebutton"
            onClick={this.handleShowModify}
          >
            <FontAwesomeIcon icon={faPencilAlt} />
          </Button>
          <Button
            className="circlebutton"
            variant="danger"
            onClick={this.handleShowDelete}
          >
            <FontAwesomeIcon icon={faTimes} />
          </Button>
          <div style={containerStyle}>
            {this.state.foodgroup[0] &&
              this.state.foodgroup
                .filter(function (value) {
                  return value.active !== false;
                })
                .slice(0, this.getmaxFoodItem())
                .map((fooditem, i) => {
                  return (
                                    
                    
                    <div style={foodItemStyle} className="newshadow">
                      <div style={containerfoodItemStyle}>
                     
                  
                    
                  
                        {fooditem.config.isUsingImage === true && this.state.switchDiamondbackground == false &&
                          <ImageFoodGroup
                            ImageUploaded={this.state.headerImage}
                            foodItemTemplate={fooditem}
                            foodItemImage={fooditem.template.picto}
                            id_foodgroup={this.state.id_foodgroup}
                            color_accent={this.state.color_accent}
                          />}
                        <div
                          style={
                            fooditem.config && fooditem.config.isUsingImage === false
                              ? bodyStyleNi
                              : bodyStyle
                          }
                        >
                         {/* {this.state.switchDiamondbackground === true &&
                         <div style={VerticaldivStyle} className="vertical-line2">
                          </div>} */}

                          <div style={overflowStyle}>
                            <div className="containerCardFg" >
                            
                              {!fooditem.tags
                                ? null
                                : fooditem.tags
                                  .filter(function (value) {
                                    return value.tag.kind == "ORIGIN";
                                  })
                                  .map(function (tag, i) {
                                    return (
                                      <h4
                                        style={originStyle}
                                        className="itemCardFg"
                                      >
                                        <FontAwesomeIcon
                                          icon={faMapMarker}
                                          className="mr-2"
                                        />
                                        {tag.tag.name}
                                      </h4>
                                    );
                                  })}

                              {!fooditem.name ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? titleNIStyle
                                      : titleStyle
                                  }
                                >
                                  {fooditem.name}
                                </h3>
                              )}
                              {!fooditem.name_secondary ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? titleSecNIStyle
                                      : titleSecStyle
                                  }
                                >
                                  {fooditem.name_secondary}
                                </h3>
                              )}
                              {!fooditem.description ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? descriptionNIStyle
                                      : descriptionStyle
                                  }
                                >
                                  {fooditem.description}
                                </h3>
                              )}
                              {!fooditem.description_secondary ? null : (
                                <h3
                                  className="itemCardFg"
                                  style={
                                    fooditem.config.isUsingImage === false
                                      ? descriptionSecNIStyle
                                      : descriptionSecStyle
                                  }
                                >
                                  {fooditem.description_secondary}
                                </h3>
                              )}
                              {!fooditem.calories ? null : (
                                <h4
                                  className="itemCardFg"
                                  style={caloriesStyle}
                                >
                                  Calories: {fooditem.calories} kcal
                                </h4>
                              )}

                              {!fooditem.tags ? null : (
                                <div
                                  className="itemCardFg"
                                  style={this.state.switchDiamondbackground === false || (fooditem.description.length !== 0 && this.state.switchDiamondbackground === true) || (this.getmaxFoodItem() > 3 && this.state.switchDiamondbackground === true)  ? allergyContStyle : allergyContStyle_AGR}
                                >
                             

                                  {fooditem.tags
                                    .filter(function (value) {
                                      return value.tag.kind == "ALLERGEN";
                                    })
                                    .map((item) => {
                                      return (
                                        <h3 style={allergyIconStyle}>
                                          {this.getIconSvg(item.tag.name)}
                                        </h3>
                                      );
                                    })}
                                </div>
                              )}
  
                            </div>

                          </div>
                        </div>
                      </div>
                      <div style={this.state.switchDiamondbackground === false ? containerLabelStyle : containerLabelStyle_AGR}>
                        {!fooditem.tags
                          ? null
                          : fooditem.tags
                            .slice(0, 3)
                            .filter(function (value) {
                              return value.tag.kind == "LABEL";
                            })
                            .map(function (tag, i) {
                              return (
                                <Image

                                  className={"newshadow"}
                                  src={tag.tag.image}
                                  style={ tagImageStyle_AGR }
                                />
                              );
                            })}
    
                      </div>
                     
                      {fooditem.prices == null ? null : (
                        fooditem.prices[0].value == 0 || fooditem.prices[0].value === null ? null : (
                      
                    
                           <div
                            style={this.state.switchDiamondbackground === false ? containerPricesStyle : containerPricesStyle_agr}
                            className={this.state.switchDiamondbackground === false ? "newshadow" : "octa"

                            } 
                          >     
                           
                           {this.state.switchDiamondbackground === true ? (
  <div>
    <h3 style={pricesStyle_AGR}>
      {this.GetPriceAdjustment(fooditem.prices[0].value,fooditem.prices[0].currency)}
    </h3>
    <h6 style={pricesStyle_AGR_h6(fooditem.prices[0].currency)}>
      {fooditem.prices[0].currency === " " ||
      fooditem.prices[0].currency === "" ||
      fooditem.prices[0].currency === "EUR" ||
      fooditem.prices[0].currency === "Eur" ||
      fooditem.prices[0].currency === "eur" ||
      fooditem.prices[0].currency === "Euro"
        ? "euros"
        : this.capitalize(fooditem.prices[0].currency.replace("PTS", "Points"))}
    </h6>
  </div>
) : (
 
  <h3 style={pricesStyle}>
    {this.GetPriceAdjustment(fooditem.prices[0].value,fooditem.prices[0].currency)}
    
    {fooditem.prices[0].currency === " " ||
    fooditem.prices[0].currency === "" ||
    fooditem.prices[0].currency === "EUR" ||
    fooditem.prices[0].currency === "Eur" ||
    fooditem.prices[0].currency === "eur" ||
    fooditem.prices[0].currency === "Euro"
      ? "€"
      : this.capitalize(fooditem.prices[0].currency.replace("PTS", "Points"))}
   </h3>
)}

                          {/*} <h6 style={this.state.switchDiamondbackground === false ? pricesStyle : pricesStyle_AGR_h6(fooditem.prices[0].currency)}>*/}
                            
                            {/*  <h6 style={ this.GetPricesStyle(fooditem.prices[0].currency)}>*/} 
                              {/*fooditem.prices[0].currency === " " ||
                                fooditem.prices[0].currency === "" ||
                                fooditem.prices[0].currency === "EUR" ||
                                fooditem.prices[0].currency === "Eur" ||
                                fooditem.prices[0].currency === "eur" ||
                                fooditem.prices[0].currency === "Euro" 
                                  ? "€"
                                : this.capitalize(
                                  fooditem.prices[0].currency.replace("PTS", "Points")
                                )}
                            </h6>*/}
                          </div>
                         
                          
                        )
                      )}

                    </div>
                  );
                })}
          </div>
        </div>
        {/* MODAL MODIFY */}
        <div onMouseDown={(e) => e.stopPropagation()}>
          <Modal
            fade={false}
            animation={false}
            className="sideMenu"
            show={this.state.show_modify}
            onHide={this.cancelOnModal}
            backdrop="static"
            keyboard={false}
            scrollable={true}
            backdropClassName="backdrop_sideMenu"
          >
            <Modal.Header closeButton>
              <Modal.Title>Change Foodgroup</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>

               {/* AGR Style*/}
               
              <Row>
                <Col md={12} className="my-2">
                    <Form.Check
                      checked={this.state.switchDiamondbackground}
                      onChange={this.handleswitchDiamondBackground}
                      type="switch"
                      id="Diamond-switch"
                      label="AGR Style"
                    />
                  </Col>
                </Row>
                     {/* AGR Style*/}
               
              <Row>
                <Col md={12} className="my-2">
                    <Form.Check
                      checked={this.state.switchSplitStyle}
                      onChange={this.handleswitchSplitStyle}
                      type="switch"
                      id="Split-switch"
                      label="Split Screen Style"
                    />
                  </Col>
                </Row>
                {/* FOODGROUP ID*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>FoodGroup Id</Form.Label>
                      <Col md={6}>
                        <InputGroup>
                          <Form.Control
                            type="number"
                            value={this.state.id_foodgroup}
                            onChange={this.handleChangeIDFoodgroup}
                          />
                          <InputGroup.Append>
                            <Button
                              variant="primary"
                              onClick={this.getFoodItems}
                            >
                              Ok
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                        <Form.Text className="text-muted">
                          FoodGroup:
                          <h6
                            className={
                              this.state.foodgroup_validation ===
                              "l'iD Food Group don't exist" && "warning"
                            }
                          >
                            {this.state.foodgroup_validation}
                          </h6>
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* FOODGROUP Image*/}
                <UploadImage
                  imageUploadedToParent={this.getImageUploaded}
                  imageFromParent={this.state.headerImage}
                />

                {/* SELECT SIZE*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Select Size</Form.Label>
                      <Col>
                        <ButtonToolbar aria-label="Toolbar with button groups">
                          <ButtonGroup
                            className="mr-2"
                            aria-label="First group"
                          >
                            <Button onClick={this.changeSize_1}>1</Button>
                            <Button onClick={this.changeSize_2}>2</Button>
                            <Button onClick={this.changeSize_3}>3</Button>
                            <Button onClick={this.changeSize_4}>4</Button>
                            <Button onClick={this.changeSize_5}>5</Button>
                          </ButtonGroup>
                        </ButtonToolbar>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
               {/* <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Override height</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.Height_bg}
                          onChange={this.handleChangeHeight}
                          min="1"
                          max="999"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          min:1 max:999 <br />
                          Height_bg: {this.state.Height_bg}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Override width</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.Width_bg}
                          onChange={this.handleChangeWidth}
                          min="1"
                          max="999"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          min:1 max:999 <br />
                          Width_bg: {this.state.Width_bg}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>*/}
                {/* SELECT  COLOR*/}
                {/* Color Background*/}
                <Row>
                  <Col md={12} className="my-2">
                    <Form.Check
                      checked={this.state.switchbackground}
                      onChange={this.handleswitchBackground}
                      type="switch"
                      id="custom-switch"
                      label="Background Color"
                    />
                  </Col>

                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Color</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          disabled={!this.state.switchbackground}
                          type="color"
                          value={this.state.color_bg}
                          onChange={this.handleChangeColor}
                        />
                        <Form.Control
                          disabled={!this.state.switchbackground}
                          className="my-2"
                          type="text"
                          value={this.state.color_bg}
                          onChange={this.handleChangeColor}
                        />

                        <Form.Text className="text-muted">
                          Color select: {this.state.color_bg}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Color Primary */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Primary Color </Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="color"
                          value={this.state.color_primary}
                          onChange={this.handleChangeColorPrimary}
                        />
                        <Form.Control
                          className="my-2"
                          type="text"
                          value={this.state.color_primary}
                          onChange={this.handleChangeColorPrimary}
                        />

                        <Form.Text className="text-muted">
                          Color select: {this.state.color_primary}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* Color Accent */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Accent Color</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="color"
                          value={this.state.color_accent}
                          onChange={this.handleChangeColorAccent}
                        />

                        <Form.Control
                          className="my-2"
                          type="text"
                          value={this.state.color_accent}
                          onChange={this.handleChangeColorAccent}
                        />

                        <Form.Text className="text-muted">
                          Color select: {this.state.color_accent}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONTFAMILY */}
                {/* FONTFAMILY Primary*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Font family Primary</Form.Label>
                      <Col md={10}>
                        <Form.Control
                          as="select"
                          onChange={this.handleChangeFontFamilyPrimary}
                          value={this.state.fontFamily_primary}
                        >
                          {listFont.map((font) => {
                            return (
                              <option
                                value={font.font}
                                style={{ fontFamily: font.font }}
                              >
                                {font.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONTFAMILY  Secondary*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Font family Secondary</Form.Label>
                      <Col md={10}>
                        <Form.Control
                          as="select"
                          onChange={this.handleChangeFontFamilySecondary}
                          value={this.state.fontFamily_secondary}
                        >
                          {listFont.map((font) => {
                            return (
                              <option
                                value={font.font}
                                style={{ fontFamily: font.font }}
                              >
                                {font.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Title */}
                {/* FONT SIZE  Title 1  */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Title 1 Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_title}
                          onChange={this.handleChangeFontSizeTitle}
                          min="25"
                          max="100"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_title}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* FONT SIZE  Title 1 No image */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Title 1 Font size No image</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_titleNi}
                          onChange={this.handleChangeFontSizeTitleNi}
                          min="25"
                          max="100"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_titleNi}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONT SIZE  Title 2  */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Title 2 Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_titleSec}
                          onChange={this.handleChangeFontSizeTitleSec}
                          min="25"
                          max="50"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_titleSec}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* FONT SIZE  Title 2 No image */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Title 2 Font size No image</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_titleSecNi}
                          onChange={this.handleChangeFontSizeTitleSecNi}
                          min="25"
                          max="50"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_titleSecNi}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Description */}
                {/* FONT SIZE Description 1 */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Description Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_description}
                          onChange={this.handleChangeFontSizeDescription}
                          min="20"
                          max="30"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_description}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONT SIZE Description 1 No image */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Description 1 No image Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_descriptionNi}
                          onChange={this.handleChangeFontSizeDescriptionNi}
                          min="22"
                          max="33"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_descriptionNi}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* FONT SIZE Description 2 */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Description 2 Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_descriptionSec}
                          onChange={this.handleChangeFontSizeDescriptionSec}
                          min="20"
                          max="30"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_descriptionSec}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONT SIZE Description 2 No image*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Description 2 No Image Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_descriptionSecNi}
                          onChange={this.handleChangeFontSizeDescriptionSecNi}
                          min="22"
                          max="33"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_descriptionSecNi}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Origin FONT SIZE */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Origin Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_origin}
                          onChange={this.handleChangeFontSizeOrigin}
                          min="20"
                          max="45"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_origin}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Calories FONT SIZE */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Calories Font size</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_calories}
                          onChange={this.handleChangeFontSizeCalories}
                          min="23"
                          max="45"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_calories}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* PRICE */}
                {/* Color BACKGROUND */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Background Color Price </Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="color"
                          value={this.state.color_priceBg}
                          onChange={this.handleChangeColorPriceBg}
                        />
                        <Form.Control
                          className="my-2"
                          type="text"
                          value={this.state.color_priceBg}
                          onChange={this.handleChangeColorPriceBg}
                        />

                        <Form.Text className="text-muted">
                          Color select: {this.state.color_priceBg}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                {/* Color Text */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Text Color Price</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="color"
                          value={this.state.color_priceTx}
                          onChange={this.handleChangeColorPriceTxt}
                        />
                        <Form.Control
                          className="my-2"
                          type="text"
                          value={this.state.color_priceTx}
                          onChange={this.handleChangeColorPriceTxt}
                        />

                        <Form.Text className="text-muted">
                          Color select: {this.state.color_priceTx}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* FONTFAMILY */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Font family Price</Form.Label>
                      <Col md={10}>
                        <Form.Control
                          as="select"
                          onChange={this.handleChangeFontFamilyPrice}
                          value={this.state.fontFamily_price}
                        >
                          {listFont.map((font) => {
                            return (
                              <option
                                value={font.font}
                                style={{ fontFamily: font.font }}
                              >
                                {font.name}
                              </option>
                            );
                          })}
                        </Form.Control>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                
                {/*  FONT SIZE */}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Font size Price</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.fontSize_price}
                          onChange={this.handleChangeFontSizePrice}
                          min="20"
                          max="100"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          font-size: {this.state.fontSize_price}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Z INDEX*/}
                <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Z-Index</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.zindex_bg}
                          onChange={this.handleChangeIndex}
                          min="1"
                          max="999"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          min:1 max:999 <br />
                          z-index: {this.state.zindex_bg}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                    <p>"No image" refers to the text size a food item has when the Image Switch in Aldebaran is off</p>
                  </Col>
                </Row>
                   {/* Curved Edges*/}
                   <Row>
                  <Col md={10}>
                    <Form.Group>
                      <Form.Label>Curved Edges Pixels</Form.Label>
                      <Col md={6}>
                        <Form.Control
                          type="number"
                          value={this.state.Curved_tb}
                          onChange={this.handleChangeCurved}
                          min="1"
                          max="999"
                          onKeyPress={(e) => {
                            e.key === "Enter" && e.preventDefault();
                          }}
                        />
                        <Form.Text className="text-muted">
                          min:1 max:999 <br />
                          Curved Edges Pixels: {this.state.Curved_tb}
                        </Form.Text>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.cancelOnModal}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.confirmChangeonModal}>
                Ok
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* MODAL DELETE */}
        <div onMouseDown={(e) => e.stopPropagation()}>
          <Modal
            show={this.state.show_delete}
            onHide={this.handleCloseDelete}
            className="modal_dark"
            backdropClassName="backdrop_modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete Food Group</Modal.Title>
            </Modal.Header>
            <Modal.Body>wonna delete?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseDelete}>
                Close
              </Button>
              <Button
                onClick={() => this.props.onRemoveItem(this.props.item.i)}
                variant="danger"
              >
                Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
}

export default FoodGroup_Land;
